import React, { Component } from "react";

class CaseStudyTitle extends Component {
  render() {
    const { company, title, description, chips = [] } = this.props;

    return (
      <div className="case-study-title">
        <div className="container">
          <div className="row">
            <div className="col-sm-10">
              <h4>{company}</h4>
              <h2>{title}</h2>
              <p className="">{description}</p>
              <p>
                {chips.map((chip, index) => (
                  <span key={index} className="chip">
                    {chip}
                  </span>
                ))}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CaseStudyTitle;
